import { UserX, AlertTriangle, Info, LogOut } from 'lucide-react';

export default function SuspendedDashboard({ user, onLogout }) {
    const formatDate = (dateString) => {
        if (!dateString) return 'No registrada';
        try {
            return new Date(dateString).toLocaleDateString();
        } catch (e) {
            return dateString;
        }
    };

    return (
        <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6 font-sans">
            <div className="max-w-md w-full bg-white rounded-2xl shadow-xl border border-slate-200 overflow-hidden animate-in fade-in duration-500">
                {/* Header */}
                <div className="bg-red-700 p-8 text-white text-center">
                    <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mx-auto mb-4 border border-white/30">
                        <UserX size={32} className="text-white" />
                    </div>
                    <h1 className="text-xl font-bold mb-1">Cuenta Suspendida</h1>
                    <p className="text-red-100/80 text-sm">
                        Su acceso académico se encuentra restringido temporalmente.
                    </p>
                </div>

                {/* Content */}
                <div className="p-8 space-y-6">
                    {/* Details Grid */}
                    <div className="grid grid-cols-2 gap-4">
                        <div className="bg-slate-50 p-4 rounded-xl border border-slate-100 text-center">
                            <span className="block text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1">Resolución</span>
                            <span className="text-sm font-semibold text-slate-800 truncate block">
                                {user?.resolucion_suspension || 'En Trámite'}
                            </span>
                        </div>
                        <div className="bg-slate-50 p-4 rounded-xl border border-slate-100 text-center">
                            <span className="block text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1">Desde el</span>
                            <span className="text-sm font-semibold text-slate-800 block">
                                {formatDate(user?.fecha_suspension)}
                            </span>
                        </div>
                    </div>

                    {/* Restricted Info */}
                    <div className="bg-amber-50 border border-amber-100 p-4 rounded-xl flex gap-3">
                        <AlertTriangle className="text-amber-500 shrink-0" size={18} />
                        <p className="text-xs text-amber-800 leading-relaxed font-semibold">
                            No podrá realizar inscripciones, visualizar notas ni descargar certificados hasta regularizar su situación ante el departamento de Kardex.
                        </p>
                    </div>

                    {/* Actions */}
                    <div className="pt-4 border-t border-slate-100 flex flex-col items-center gap-4">
                        <div className="flex items-center gap-2 text-xs text-slate-500 self-start">
                            <Info size={14} />
                            <span>Departamento de Kardex</span>
                        </div>
                        
                        <button 
                            onClick={onLogout}
                            className="mt-2 w-full flex items-center justify-center gap-2 px-6 py-3 bg-slate-800 text-white rounded-xl hover:bg-slate-900 transition-all shadow-md text-sm font-bold"
                        >
                            <LogOut size={18} />
                            Cerrar Sesión
                        </button>
                    </div>
                </div>

                {/* Footer */}
                <div className="bg-slate-50 py-4 px-8 text-center border-t border-slate-100">
                    <p className="text-[10px] font-medium text-slate-400 uppercase tracking-tighter">
                        © EBID - SISTEMA DE GESTIÓN ACADÉMICA
                    </p>
                </div>
            </div>
        </div>
    );
}
